import { apiClient } from '@packages/api-client';

const getGatewayBaseURL = () => {
  const v = (window as any)._intellix_server_config?.gatewayBaseUrl;
  return (typeof v === 'string' && v.startsWith('http') ? v : null) ||
    import.meta.env.VITE_GATEWAY_BASE_URL ||
    'https://gateway-dev.aialign.cn';
};

// 权限模式
export type PermissionMode = 'PRIVATE' | 'PUBLIC' | 'CUSTOM';

// 授权对象类型
export type GranteeType = 'USER' | 'DEPARTMENT';

// 授权对象展示 VO
export interface GranteeVO {
  granteeType: GranteeType;
  granteeId: number;
  displayName: string;
  avatarUrl: string | null;
}

// 权限配置响应
export interface OntologyPermissionConfigVO {
  viewMode: PermissionMode;
  editMode: PermissionMode;
  viewGrantees: GranteeVO[];
  editGrantees: GranteeVO[];
}

// 权限保存请求
export interface OntologyPermissionConfigRequest {
  viewMode: PermissionMode;
  editMode: PermissionMode;
  viewGrantees: { granteeType: GranteeType; granteeId: number }[];
  editGrantees: { granteeType: GranteeType; granteeId: number }[];
}

// 部门树节点
export interface DeptTreeNode {
  id: number;
  parentId: number;
  deptName: string;
  children: DeptTreeNode[];
}

// 人员选择条目
export interface UserPickItem {
  userId: number;
  employeeId: number;
  username: string;
  email: string;
}

// 部门人员树节点
export interface DeptUserTreeNode {
  id: number;
  parentId: number;
  deptName: string;
  users: UserPickItem[];
  children: DeptUserTreeNode[];
}

export class PermissionApi {
  /**
   * 查询本体权限配置
   */
  static async getPermissions(ontologyId: number): Promise<OntologyPermissionConfigVO> {
    const res = await apiClient.get<OntologyPermissionConfigVO>(`/ontologies/${ontologyId}/permissions`);
    return res.data;
  }

  /**
   * 保存本体权限配置（原子替换）
   */
  static async savePermissions(
    ontologyId: number,
    request: OntologyPermissionConfigRequest
  ): Promise<void> {
    await apiClient.put(`/ontologies/${ontologyId}/permissions`, request);
  }

  /**
   * 获取部门树（用户中心接口）
   */
  static async getDeptTree(keyword?: string): Promise<DeptTreeNode[]> {
    const params = keyword ? `?keyword=${encodeURIComponent(keyword)}` : '';
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${getGatewayBaseURL()}/aialign-user-service/v1/dept/tree${params}`, {
      headers: { Authorization: `Bearer ${token ?? ''}` },
    });
    const json = await res.json();
    return json.data ?? [];
  }

  /**
   * 获取部门人员树（用户中心接口）
   */
  static async getUserPickTree(username?: string): Promise<DeptUserTreeNode[]> {
    const params = username ? `?username=${encodeURIComponent(username)}` : '';
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${getGatewayBaseURL()}/aialign-user-service/v1/user/pick-tree${params}`, {
      headers: { Authorization: `Bearer ${token ?? ''}` },
    });
    const json = await res.json();
    return json.data ?? [];
  }
}
